import { render } from "./Pix.vue?vue&type=template&id=7a38808a&scoped=true"
import script from "./Pix.vue?vue&type=script&lang=js"
export * from "./Pix.vue?vue&type=script&lang=js"

import "./Pix.vue?vue&type=style&index=0&id=7a38808a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a38808a"]])

export default __exports__